import dayjs from 'dayjs';
import { QrCodeVisitStatus, Query } from 'graphql/generated/graphqlTypes';
import { generateMockQrCodeVisitWeb } from 'mocks/graphqlMocks/qrCodeVisitWeb';
import { generateMockVisitor } from 'mocks/graphqlMocks/visitor';

const visitDate = (daysFromToday: number, hour: number, minute = 0) =>
  dayjs().add(daysFromToday, 'day').hour(hour).minute(minute).second(0).millisecond(0).toISOString();

// Today's visit must stay ahead of `now` so the Upcoming filter (`datetime >= now`)
// keeps it on the Upcoming tab regardless of when the mock is loaded.
const laterToday = (hoursFromNow: number) => dayjs().add(hoursFromNow, 'hour').second(0).millisecond(0).toISOString();

const pastVisitDate = (daysAgo: number, hour: number, minute = 0) =>
  dayjs().subtract(daysAgo, 'day').hour(hour).minute(minute).second(0).millisecond(0).toISOString();

export const mockedGetQrCodeVisitsForTenantData: Pick<Query, 'getQrCodeVisitsForTenant'> = {
  getQrCodeVisitsForTenant: [
    generateMockQrCodeVisitWeb({
      id: 'mockedUpcomingQrCodeVisitId1',
      name: 'John Guest',
      email: 'john.guest@mock.com',
      datetime: laterToday(2),
      host: generateMockVisitor({
        id: 'mockedHostId1',
        name: 'Alice Host',
        email: 'alice.host@mock.com'
      }),
      status: QrCodeVisitStatus.Valid
    }),
    generateMockQrCodeVisitWeb({
      id: 'mockedUpcomingQrCodeVisitId2',
      name: 'Jane Guest',
      email: 'jane.guest@mock.com',
      datetime: visitDate(1, 10),
      host: generateMockVisitor({
        id: 'mockedHostId2',
        name: 'Bob Host',
        email: 'bob.host@mock.com'
      }),
      status: QrCodeVisitStatus.Valid
    }),
    generateMockQrCodeVisitWeb({
      id: 'mockedUpcomingQrCodeVisitId3',
      name: 'Tom Guest',
      email: 'tom.guest@mock.com',
      datetime: visitDate(2, 11),
      host: generateMockVisitor({
        id: 'mockedHostId3',
        name: 'Carol Host',
        email: 'carol.host@mock.com'
      }),
      status: QrCodeVisitStatus.Valid
    }),
    generateMockQrCodeVisitWeb({
      id: 'mockedUpcomingQrCodeVisitId4',
      name: 'Dave Guest',
      email: 'dave.guest@mock.com',
      datetime: visitDate(10, 12),
      host: generateMockVisitor({
        id: 'mockedHostId10',
        name: 'Grace Host',
        email: 'grace.host@mock.com'
      }),
      status: QrCodeVisitStatus.Valid
    }),
    generateMockQrCodeVisitWeb({
      id: 'mockedPastQrCodeVisitId1',
      name: 'Sara Guest',
      email: 'sara.guest@mock.com',
      datetime: pastVisitDate(1, 10),
      host: generateMockVisitor({
        id: 'mockedHostId4',
        name: 'Diana Host',
        email: 'diana.host@mock.com'
      }),
      status: QrCodeVisitStatus.Used
    }),
    generateMockQrCodeVisitWeb({
      id: 'mockedPastQrCodeVisitId2',
      name: 'Liam Guest',
      email: 'liam.guest@mock.com',
      datetime: pastVisitDate(1, 14),
      host: generateMockVisitor({
        id: 'mockedHostId6',
        name: 'Frank Host',
        email: 'frank.host@mock.com'
      }),
      status: QrCodeVisitStatus.Valid
    }),
    generateMockQrCodeVisitWeb({
      id: 'mockedCancelledQrCodeVisitId1',
      name: 'Oliver Guest',
      email: 'oliver.guest@mock.com',
      datetime: visitDate(3, 10),
      host: generateMockVisitor({
        id: 'mockedHostId5',
        name: 'Eve Host',
        email: 'eve.host@mock.com'
      }),
      status: QrCodeVisitStatus.Cancelled
    })
  ]
};
